import BarrioIngresoPagina from "./BarrioIngresoPagina";

export default BarrioIngresoPagina;